export default __webpack_public_path__ + "static/media/onishi.906f83aa.png";